'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader
const verihub = ENV.verihub

const actions = {
  getUserByEmailOrUsername(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/findbyemailorusername`
        const result = await axios.get(url, {
          ...costumHeader('Get Personal Detail', 4),
          params,
          timeout: 15000
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },

  deleteUserFace(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${verihub.url}/v1/face/enroll?subject_id=Appsensi_${params.companyId}_${params.userId}`
        const result = await axios.delete(url, {headers: {'API-Key': verihub.key, 'App-ID': verihub.id}

        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteUser(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/delete`
        const result = await axios.post(url, body, costumHeader('Delete User', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
}

export default { actions }